export enum LayoutSelectedTab {
  Schedule = 'Schedule',
  Overview = 'Overview',
}
